export const sermons = [
  {
    id: 1,
    title: "Your Body is a Temple: Honoring God Through Health",
    date: "March 30, 2026",
    duration: "42 min",
    scripture: "1 Corinthians 6:19-20",
    thumbnail: "https://public.readdy.ai/ai/img_res/82910cc81509b14c86f8b2f6fcf962fb.jpg",
    youtubeUrl: "#",
  },
  {
    id: 2,
    title: "Faith in the Valley of Illness",
    date: "March 23, 2026",
    duration: "38 min",
    scripture: "Psalm 23:4",
    thumbnail: "https://readdy.ai/api/search-image?query=Open%20Bible%20with%20soft%20light%20and%20cross%20shadow%2C%20peaceful%20devotional%20atmosphere%2C%20warm%20tones%2C%20close%20up%20photography&width=600&height=340&seq=sermon2&orientation=landscape",
    youtubeUrl: "#",
  },
  {
    id: 3,
    title: "Healing is His Promise",
    date: "March 16, 2026",
    duration: "45 min",
    scripture: "Jeremiah 30:17",
    thumbnail: "https://readdy.ai/api/search-image?query=Hands%20raised%20in%20worship%20during%20church%20service%2C%20warm%20golden%20light%2C%20spiritual%20atmosphere%2C%20wide%20angle%20photography&width=600&height=340&seq=sermon3&orientation=landscape",
    youtubeUrl: "#",
  },
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Faith & Wellness Workshop",
    date: "Apr 12, 2026",
    time: "10:00 AM – 1:00 PM",
    location: "Grace Community Church, Main Hall",
    description: "A half-day workshop combining health education with spiritual renewal.",
  },
  {
    id: 2,
    title: "Sunday Bible Study: Healing Scriptures",
    date: "Apr 19, 2026",
    time: "9:00 AM – 10:30 AM",
    location: "Online via Zoom",
    description: "Deep dive into healing scriptures and their application to modern health challenges.",
  },
  {
    id: 3,
    title: "Community Prayer & Health Screening",
    date: "Apr 26, 2026",
    time: "8:00 AM – 12:00 PM",
    location: "Grace Community Church, Fellowship Hall",
    description: "Free blood sugar and thyroid screenings followed by a community prayer service.",
  },
  {
    id: 4,
    title: "Hormone Health Seminar",
    date: "May 3, 2026",
    time: "2:00 PM – 4:00 PM",
    location: "Online Webinar",
    description: "Educational seminar on hormonal health for women, hosted by Dr. Sheldon Mckenzie.",
  },
];

export const devotional = {
  quote: "\"For I will restore health to you, and your wounds I will heal, declares the Lord.\"",
  scripture: "— Jeremiah 30:17",
  reflection: "God's promise of healing is not just physical — it encompasses our mind, spirit, and body. As we trust in His plan, we open ourselves to wholeness in every dimension of our lives.",
};
